<template lang="pug">
  .locked-single-coupon-tab(
    :style="noBorderFlag?'border:none':''"
    :class="{'ladder-blend': ['ladder_blend', 'ladder_blend_two'].includes(version)}")
    .first-bussuness-line
      .bussuness-left
        img.bussuness-icon(:src="tempObj.businessLineIcon")
        .bussiness-name {{tempObj.businessLineName}}
        .bussiness-text {{splitProgressText(tempObj.openCurrentProgressDesc)[0]}}
        .bussiness-text-count {{(tempObj.currentProgressNum
                            || tempObj.currentProgressNum === 0) ? tempObj.currentProgressNum:'*'}}
        .bussiness-text {{splitProgressText(tempObj.openCurrentProgressDesc)[1]}}
      //- .bussiness-button(@click="testProgress") 测试红包{{this.finish}}
      .bussiness-button(@click="goToUse") {{tempObj.jumpButtonDesc}}
    .coupons-progress-container
      .coupons-progress
        .locked-coupons
          .packet-container.flex-mid(v-for="(item, index) in getCouponList()")
            .packet-block-container(:class="(![1,2,8].includes(item.status))?'white-mask':''")
              .packet-block(:class="firstWait === index && (version!=='ladder_blend'&&version !== 'ladder_blend_two')? 'first-wait':''"
                            :style= "getPacketBg(item)")
                .bussiness-line(v-if="version === 'ladder_blend'||version === 'ladder_blend_two'") {{getBus(item)}}
                .price
                  .num  {{(item.propType!==4&&item.propType!==7)?item.amount:item.propTimes}}
                  .yuan {{((item.propType!==4&&item.propType!==7))?item.unit:'次'}}
                .no-threshold {{(item.propType === 4||item.propType===7)?`${item.propEffectiveDays}天可用`:item.subtitle}}
                .receive-button(@click="receiveCoupon(item)"
                                :class="getBtnClass(item.status)"
                                :style="(version === 'ladder_blend'||version === 'ladder_blend_two')?'':getFontSize( \
                                getName(item.btnName),(firstWait === index))") {{getName(item.btnName)}}
            img.finish-icon(v-if="(finish !== null) &&(finish >= index ) \
              && tempObj.currentProgressNum !== undefined" :src="progressFinishDot")
            img.red-dot-img.flex-mid(v-else :class="(index > finish)? 'light':'' " :src="progressUnfinishDot")
            template(v-if="version === 'ladder_blend'|| version === 'ladder_blend_two'")
              .finish-count(v-html="getLadderStatus(item)")
            template(v-else)
              .finish-count(v-if="item.ladderNum === (tempObj.currentProgressNum + 1)"
                            :class="firstWait === index ? 'deep-color':''")
                .finish-count-number 本单
                span 可领
              .finish-count(v-else :class="firstWait === index ? 'deep-color':''")
                span {{splitProgressText(tempObj.openProgressDesc)[0]}}
                .finish-count-number {{(item.ladderNum||item.ladderNum === 0) ? item.ladderNum:'*'}}
                span {{splitProgressText(tempObj.openProgressDesc)[1]}}
        .progress-block
            .progress-bar(v-if="(tempObj.currentProgressNum!==undefined)"
                          :style="`width:${getWidth()}`")
            img.progress-fire-icon(v-if="showFireFlag && (version !=='ladder_blend'&&version !== 'ladder_blend_two')" src="https://m.hellobike.com/resource/helloyun/22042/MSIvQfl_pE.png")
</template>


<script>
import Lottie from '@/components/lottie';
import { env } from '@hb/hbridge';
import { commonGoLink } from '@/utils';
import { findLastIndex } from 'lodash';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import {
  desc, getName, getFontSize, groupByLadderArray,
} from '../utils.js';
import { COUPON_STATUS, COUPON_PROGRESS_STATUS_MAP } from '../../consts.js';


const BUTTON_IMG = 'https://m.hellobike.com/resource/gallery/43/ROG9EfRf_283.png';


export default {
  components: {
    Lottie,
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
    ladderDetailMap: {
      type: Object,
      required: true,
    },
    noBorderFlag: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      finish: null, // 已完成的红包index
      currentProgressNum: 0, // 已完成的单数
      tempObj: {},
      ladderArray: [],
      coupons: [],
      BUTTON_IMG,
    };
  },
  computed: {
    version() {
      if (this.getPropVersion) {
        return this.getPropVersion();
      }
      return '';
    },
    firstWait() {
      return this.finish === null ? 0 : this.finish + 1;
    },
    showFireFlag() {
      return (
        this.tempObj.currentProgressNum !== undefined
          && this.finish < this.info.propList.length - 1
      );
    },
    progressFinishDot() {
      if (this.version === 'ladder_blend' || this.version === 'ladder_blend_two') {
        return 'https://m.hellobike.com/resource/gallery/43/OnLPWCa1_232.png';
      }
      return 'https://m.hellobike.com/resource/helloyun/22042/5EugRDHU9Y.png';
    },
    progressUnfinishDot() {
      if (this.version === 'ladder_blend' || this.version === 'ladder_blend_two') {
        return 'https://m.hellobike.com/resource/gallery/43/fs2Tq1F3_128891.png';
      }
      return 'https://m.hellobike.com/resource/helloyun/22042/8ex-M6NZBj.png';
    },
  },
  watch: {
    info: {
      handler() {
        this.coupons = groupByLadderArray(this.info.propList);
        this.getInfo();
        this.getFinishIndex();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
  },
  inject: ['openSelectModal', 'getPropVersion'],
  methods: {
    getFontSize,
    desc,
    getName,
    getCouponList() {
      if (this.getPropVersion() === 'ladder_blend_two') {
        return this.coupons;
      }
      return this.coupons.slice(0, 4);
    },
    getBus(item) {
      if (this.getPropVersion && (this.getPropVersion() === 'ladder_blend' || this.getPropVersion() === 'ladder_blend_two')) {
        if ([COUPON_STATUS.receive, COUPON_STATUS.locked].includes(item.status) && item.multiFlag) {
          return this.tempObj && this.tempObj.businessLineName;
        }
        return item.goodsPropDesc || '';
      }
      return '';
    },
    getLadderStatus(item) {
      const { openProgressDesc = '' } = this.tempObj;
      const { status, ladderNum = 0 } = item;

      if (status !== COUPON_STATUS.locked) {
        if (status === COUPON_STATUS.receive) {
          return `
        <span style="color:#242729;font-weight:500">
        ${COUPON_PROGRESS_STATUS_MAP[item.status]}
        </span>
      `;
        }
        return `${COUPON_PROGRESS_STATUS_MAP[item.status]}`;
      }

      // 返回一个包含 Vue 模板的 HTML 元素
      return `${this.splitProgressText(openProgressDesc)[0] || ''}${(ladderNum || ladderNum === 0) ? ladderNum : '*'}${this.splitProgressText(openProgressDesc)[1] || ''}`;
    },
    getBtnClass(status) {
      if ([COUPON_STATUS.use, COUPON_STATUS.receive, COUPON_STATUS.wait,
        COUPON_STATUS.expansived, COUPON_STATUS.recovery].includes(status)) {
        return 'golden-button';
      }
      return '';
    },
    getPacketBg(item) {
      if (item.multiFlag && (this.version === 'ladder_blend' || this.getPropVersion() === 'ladder_blend_two')) {
        return 'background-image: url(https://m.hellobike.com/resource/gallery/43/IgHSRDAU_Group%201707482283.png)';
      }
      return '';
    },
    receiveCoupon(item) {
      if (item.multiFlag && this.openSelectModal && item.status
          && item.status === COUPON_STATUS.receive && this.getPropVersion && (this.getPropVersion() === 'ladder_blend' || this.getPropVersion() === 'ladder_blend_two')) {
        this.openSelectModal(item);
      } else {
        this.$emit('clickReceive', item);
      }
    },
    getWidth() {
      if (this.version === 'ladder_blend_two') {
        if (this.finish === this.info.propList.length - 1) {
          return '100%';
        }
      }
      if (this.finish === this.info.propList.length - 1 || this.finish >= 3) {
        return '100%';
      }
      if (this.version === 'ladder_blend' || this.version === 'ladder_blend_two') {
        return `${
          this.finish !== null ? 0.81 * (+this.finish) + 0.37 : 0
        }rem`;
      }
      return `${
        this.finish !== null ? 0.85 * (+this.finish + 1) + 0.14 : 0.26
      }rem`;
    },
    splitProgressText(progressDesc = '') {
      return progressDesc.split('%s');
    },
    getInfo() {
      const valuesList = Object.values(this.ladderDetailMap);
      // eslint-disable-next-line no-restricted-syntax
      for (const i of valuesList) {
        if (i.ladderMarsCode === this.info.groupCode) {
          this.tempObj = i;
        }
      }
    },
    getFinishIndex() {
      // 获取当前完成的红包进度index
      let ladderArray = [];
      if (this.coupons && this.coupons.length) {
        ladderArray = this.coupons.map((item) => item.ladderNum || 0);
      }
      if (
        ladderArray.length
          && this.tempObj
          && this.tempObj.currentProgressNum !== undefined
      ) {
        const tempFinish = findLastIndex(
          ladderArray,
          (item) => item <= this.tempObj.currentProgressNum,
        );
        this.finish = tempFinish >= 0 ? tempFinish : null;
      }
    },
    goToUse() {
      const propBusinessLine = this.info.propList && this.info.propList.length ? this.info.propList[0].propBusinessLine : '';
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_copuon_daoliu',
        categoryId: 'platform',
        businessInfo: {
          BusinessLine: propBusinessLine,
        },
      });
      if (env.isEasyBikeApp) {
        if (this.tempObj && this.tempObj.appJumpUrl) {
          commonGoLink(this.tempObj.appJumpUrl);
        }
      } else {
        this.$emit('notInAppJump');
      }
    },

    testProgress() {
      if (this.finish === null) {
        this.finish = 0;
      } else if (this.finish === this.info.propList.length - 1) {
        this.finish = null;
      } else {
        this.finish += 1;
      }
      if (this.finish !== null) {
        this.currentProgressNum = this.finish + 1;
      }
    },
  },
};
</script>
  <style lang="less" scoped>
.locked-single-coupon-tab {
  margin-bottom: 0.18rem;
  border-bottom: 0.01rem solid rgba(240, 243, 245, 0.5);

  &:last-of-type {
    margin-bottom: 0;
    padding-bottom: 0.04rem;
  }

  .first-bussuness-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.1rem;

    & * {
      white-space: nowrap; /* 所有后代元素都继承该样式 */
    }

    .bussuness-left {
      display: flex;
      align-items: center;
      justify-content: center;

      .bussuness-icon {
        height: 0.2rem;
        margin-right: 0.02rem;
        object-fit: contain;
      }

      .bussiness-name {
        margin-right: 0.08rem;
        height: 0.2rem;
        font-size: 0.14rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        color: #242729;
        line-height: 0.2rem;
      }

      .bussiness-text {
        height: 0.18rem;
        font-size: 0.13rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #531900;
        line-height: 0.18rem;
      }

      .bussiness-text-count {
        text-align: center;
        width: 0.14rem;
        background: #fff4e1;
        border-radius: 0.04rem;
        height: 0.19rem;
        font-size: 0.16rem;
        line-height: 0.19rem;
        font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
        font-weight: 600;
        color: #fa4614;
      }
    }

    .bussiness-button {
      width: 0.6rem;
      height: 0.24rem;
      background: #ffeee6;
      border-radius: 0.12rem;
      text-align: center;
      font-size: 0.12rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      color: #fa4614;
      line-height: 0.24rem;
    }
  }

  .coupons-progress-container {
    overflow-x: auto;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
      color: transparent;
    }
  }

  .coupons-progress {
    position: relative;
    padding-bottom: 0.14rem;
    width: fit-content;

    .locked-coupons {
      position: relative; //使z-index生效
      z-index: 2;
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;

      .white-mask {
        opacity: 0.4;
      }

      .packet-container {
        display: flex;
        flex-direction: column;
        margin-right: 0.16rem;

        &:last-child {
          margin-right: 0;
        }

        .finish-icon {
          margin: 0.07rem auto 0.03rem auto;
          width: 0.18rem;
          height: 0.18rem;
        }

        .red-dot-img {
          margin: 0.105rem 0 0.085rem;
          // flex: 1;
          max-width: 0.06rem;
          max-height: 0.06rem;
          min-width: 0.06rem;
          min-height: 0.06rem;
        }

        .light {
          opacity: 0.4;
        }

        .finish-count {
          display: flex;
          justify-content: center;
          height: 0.16rem;
          font-size: 0.13rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: rgba(83, 25, 0, 0.5);
          line-height: 0.16rem;
          flex-wrap: nowrap;
          white-space: nowrap;
          // width: 0.65rem;
          overflow: visible;

          .finish-count-number {
            height: 0.16rem;
            font-size: 0.13rem;
            font-family: PingFangSC-Regular, PingFang SC, sans-serif;
            line-height: 0.16rem;
          }
        }

        .deep-color {
          color: #531900;

          .finish-count-number {
            font-family: PingFangSC-Medium, PingFang SC, sans-serif;
            font-weight: 500;
          }
        }
      }

      .packet-block-container {
        height: 0.91rem;
        display: flex;
        align-items: flex-end;

        .packet-block {
          width: 0.67rem;
          height: 0.7826rem;
          background: #fff;
          background-image: url(https://m.hellobike.com/resource/gallery/43/4qt9wOEBSz.png);
          background-size: 100% 100%;
          // padding-top: 0.04rem;

          &:last-child {
            margin-right: 0;
          }

          .price {
            display: flex;
            justify-content: center;
            align-items: flex-end;

            .num {
              height: 0.28rem;
              font-size: 0.24rem;
              font-family: DINAlternate-Bold, DINAlternate, sans-serif;
              font-weight: bold;
              color: #f54311;
              line-height: 0.32rem;
            }

            .yuan {
              margin: 0 0 0.03rem 0.01rem;
              width: 0.1rem;
              height: 0.1rem;
              font-size: 0.1rem;
              font-family: PingFangSC-Regular, PingFang SC, sans-serif;
              font-weight: 400;
              color: #f54311;
              line-height: 0.1rem;
            }
          }

          .no-threshold {
            margin: 0 auto;
            width: fit-content;
            height: 0.16rem;
            font-size: 0.11rem;
            font-family: PingFangSC-Regular, PingFang SC, sans-serif;
            font-weight: 400;
            color: #b16652;
            line-height: 0.16rem;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .receive-button {
            text-align: center;
            width: fit-content;
            margin: 0.14rem auto 0 auto;
            height: 0.14rem;
            font-size: 0.11rem;
            font-family: PingFangSC-Medium, PingFang SC, sans-serif;
            font-weight: 500;
            color: #fff;
            line-height: 0.14rem;
          }

          .golden-button {
            color: #7d3b2a;
            width: 0.48rem;
            height: 0.17rem;
            line-height: 0.165rem;
            background-image: url(https://m.hellobike.com/resource/gallery/43/sfAmc1xwZp.png);
            background-size: 100% 100%;
          }
        }

        .first-wait {
          padding-top: 0.05rem;
          width: 0.78rem;
          height: 0.91rem;

          .price {
            .num {
              height: 0.3rem;
              font-size: 0.26rem;
              line-height: 0.3rem;
            }

            .yuan {
              font-size: 0.11rem;
              margin: 0 0 0.06rem 0.01rem;
              width: 0.12rem;
              height: 0.11rem;
              line-height: 0.11rem;
            }
          }

          .receive-button {
            margin-top: 0.16rem;
            height: 0.16rem;
            font-size: 0.12rem;
            line-height: 0.16rem;
          }
        }
      }
    }

    .progress-block {
      z-index: 1;
      position: absolute;
      bottom: 0.39rem;
      left: 0;
      height: 0.05rem;
      background: #ffefea;
      border-radius: 0.03rem;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      width: 100%;

      .progress-bar {
        z-index: 2;
        width: 0;
        height: 0.05rem;
        background: linear-gradient(270deg, #fa8722 0%, #fa4614 100%);
        box-shadow: inset 0 0.01rem 0 0 rgba(255, 255, 255, 0.62);
        border-radius: 0.03rem;
      }

      .progress-fire-icon {
        margin-left: -0.3rem;
        z-index: 3;
        width: 0.34rem;
        height: 0.13rem;
      }
    }
  }

  .more-coupons-bar {
    width: 3.27rem;
    height: 0.32rem;
    margin: 0 auto;
  }

  &.ladder-blend {
    .first-bussuness-line {
      .bussuness-left {
        .bussiness-text {
          color: #373b3e;
          font-family: "PingFang SC", sans-serif;
          font-size: 0.12rem;
        }
      }
    }

    .coupons-progress {
      .locked-coupons {
        .packet-container {
          margin-right: 0.05rem;

          &:last-child {
            margin-right: 0;
          }

          .red-dot-img {
            margin-top: 0.138rem;
            width: 0.08rem;
            height: 0.08rem;
          }

          .light {
            opacity: 1;
          }

          .packet-block-container {
            height: 1.05365rem;

            .bussiness-line {
              margin-top: 0.08rem;
              height: 0.12rem;
              line-height: 0.12rem;
              text-align: center;
              color: #5a6066;
              font-family: "PingFang SC", sans-serif;
              font-weight: 500;
              font-size: 0.11rem;
            }

            .golden-button {
              box-sizing: border-box;
              overflow: hidden;
              min-width: 0.56rem;
              max-width: 0.68rem;
              padding: 0 0.03rem;
              color: #7d3b2a;
              height: 0.2rem;
              line-height: 0.2rem;
              background: linear-gradient(94.85deg, #ffe9d0 17.2%, #ffdcb4 98.24%);
              border-radius: 0.1rem;
            }

            .packet-block {
              width: 0.78rem;
              height: 1.06rem;
              position: relative;
              background-image: url(https://m.hellobike.com/resource/gallery/43/2RFmiHU89r.png?x-oss-process=image/quality,q_80);
              background-size: contain;
              background-repeat: no-repeat;
              background-position: bottom center;

              .price {
                margin-top: 0.01rem;

                .num {
                  font-size: 0.26rem;
                }

                .yuan {
                  font-size: 0.11rem;
                }
              }

              .no-threshold {
                margin-top: 0.01rem;
                font-size: 0.11rem;
                color: #b16652;
              }

              .button-bg {
                position: absolute;
                bottom: 0.0614rem;
                left: 0.11rem;
                width: 0.56rem;
                height: 0.20282rem;
              }

              .receive-button {
                height: 0.2rem;
                line-height: 0.2rem;
                font-size: 0.12rem;
                margin-top: 0.15rem;
                z-index: 1;
                position: relative;
              }
            }
          }

          .finish-count {
            color: #879099;
          }
        }
      }

      .progress-block {
        background: #f0f3f5;

        .progress-bar {
          background: #fa4614;
        }
      }
    }
  }
}
  </style>
